import React, { useMemo } from 'react';
import { WallPost } from '../../../api/wallPostsApi';
import { getMediaUrl } from '../../../utils/avatarUtils';
import styles from './PhotoGrid.module.css';

interface PhotoGridProps {
  posts: WallPost[];
  onPostClick: (post: WallPost, imageIndex: number) => void;
}

interface GridItem {
  post: WallPost;
  imageUrl: string;
  imageIndex: number;
  hasMultipleImages: boolean;
}

const PhotoGrid: React.FC<PhotoGridProps> = ({ posts, onPostClick }) => {
  // Формируем плоский список всех фотографий с привязкой к постам
  const gridItems = useMemo<GridItem[]>(() => {
    const items: GridItem[] = [];
    
    posts.forEach(post => {
      if (post.images && post.images.length > 0) {
        // Добавляем первую фотографию каждого поста (avatar — миниатюра для сетки)
        const imageUrl = getMediaUrl(post.images[0], 'avatar') || getMediaUrl(post.images[0], 'full');
        if (imageUrl) {
          items.push({
            post,
            imageUrl,
            imageIndex: 0,
            hasMultipleImages: post.images.length > 1
          });
        }
      }
    });
    
    return items;
  }, [posts]);

  if (gridItems.length === 0) {
    return (
      <div className={styles.emptyGrid}>
        <i className="ri-image-line"></i>
        <p>Нет фотографий</p>
        <span>Создайте пост с фотографиями</span>
      </div>
    );
  }

  return (
    <div className={styles.photoGrid}>
      {gridItems.map((item, index) => (
        <div 
          key={`${item.post.id}-${item.imageIndex}`}
          className={styles.gridItem}
          onClick={() => onPostClick(item.post, item.imageIndex)}
        >
          <img 
            src={item.imageUrl}
            alt={`Пост ${item.post.id}`}
            className={styles.gridImage}
            loading="lazy"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          />
          
          {/* Индикатор нескольких фото */}
          {item.hasMultipleImages && (
            <div className={styles.multipleIndicator}>
              <i className="ri-stack-line"></i>
            </div>
          )}
          
          {/* Оверлей при наведении */}
          <div className={styles.hoverOverlay}>
            <div className={styles.stats}>
              <span className={styles.stat}>
                <i className="ri-heart-fill"></i>
                {item.post.likes}
              </span>
              <span className={styles.stat}>
                <i className="ri-chat-3-fill"></i>
                {item.post.comments}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PhotoGrid;
